import Hero from "../shared/Hero";

export default function OpeningsHero() {
  return (
    <Hero
      
      title="Careers"
      description="Join VerdeMobility and help power the electric mobility revolution. We're building next-generation EV charging infrastructure for homes, businesses, and public spaces — and we're looking for people who want to build the future with us."
    />
  );
}
